import { combine, createStore } from "effector";
import { TRequestParams } from "../../../shared/commonTypes/commonTypes";
import { resetQuery, resetToken, setInitializing, setQuery } from "./events";
import { validateTokenFx } from "./effects";
import { IValidateResponse } from "./types";

// Проверка валидации токена при наличии query в URL
export const $isValidToken = createStore<IValidateResponse | null>(null)
    .on(validateTokenFx.done, () => {
        return {
            detail: '',
            is_valid: true
        }
    })
    .on(validateTokenFx.failData, (_, error) => {
        return {
            is_valid: false,
            detail: error.message
        }
    })
    .reset(resetToken);


// Стор с query параметрами из URL
export const $query = createStore<TRequestParams | null>(null)
	.on(setQuery, (_, query) => query)
    .reset(resetQuery);


// Признак инициализации страницы
export const $isInitializing = createStore(false)
    .on(setInitializing, () => true);


export const $validTokenAndQuery = combine({
    validToken: $isValidToken,
    query: $query,
})